import {AuthContext} from "@buildwitt/shapeshift-identity";
import axios from "axios";
import {useContext} from "react";

const useEnrollmentActions = () => {
	const {jwt} = useContext(AuthContext);
	const API_HOST = process.env.REACT_APP_API_HOST;

	const updateLatestLessonCompletedAt = (completedAt: Date) => {
		axios.put(
			`${API_HOST}/api/user/lessonCompletedAt`,
			{lessonCompletedAt: completedAt},
			{headers: {
				Authorization: `Bearer ${jwt}`
			}
			}
		);
	}

	return {
		updateLatestLessonCompletedAt
	}
}

export default useEnrollmentActions;